import {
  Autocomplete,
  BaseTextFieldProps,
  Chip,
  TextField,
} from '@mui/material'
import * as React from 'react'

interface Props extends BaseTextFieldProps {
  label: string
  disabled?: boolean
  disableClearable?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  fixedOptions?: {
    name: string
    id: number
  }[]
  options: {
    name: string
    id: number
  }[]
  handleSelect: (val: { name: string; id: number }[]) => void
}

export default function MultipleSelectCheckMarks({
  label,
  options,
  fixedOptions = [],
  disableClearable,
  variant = 'outlined',
  handleSelect,
  disabled,
  ...props
}: Props) {
  const [state, setState] = React.useState<typeof options>([...fixedOptions])
  React.useEffect(() => {
    handleSelect(state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return (
    <Autocomplete
      sx={{
        my: 2,
      }}
      multiple
      fullWidth
      // size="small"
      autoHighlight
      value={state}
      onChange={(event, newValue) => {
        setState([
          ...fixedOptions,
          ...newValue.filter((option) => fixedOptions.indexOf(option) === -1),
        ])
      }}
      options={options}
      getOptionLabel={(option) => option.name}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            label={option.name}
            {...getTagProps({ index })}
            disabled={fixedOptions.indexOf(option) !== -1}
            // size="small"
            sx={{
              px: 1,
            }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} label={label} {...props} />
      )}
    />
  )
}
